<section class="content-dialog">
    <div class="content-text">
        <h3 class="question">
            {{ "CREDIT.typeDialog.bitcar.title" | translate }}
        </h3>
        <p>
            {{ "CREDIT.typeDialog.bitcar.text" | translate }}
        </p>
        <div class="content-button">
            <button class="btn btn-action" [mat-dialog-close]="false" mat-button id="boton-credito-bitcar{{templateSuffix !== '' ? '-b' : ''}}">
                {{ "CREDIT.typeDialog.bitcar.button" | translate }}
            </button>
        </div>
    </div>
    <div class="content-text">
        <h3 class="question">
            {{ "CREDIT.typeDialog.ballon.title" | translate }}
        </h3>
        <p>
            {{ "CREDIT.typeDialog.ballon.text" | translate }}
        </p>
        <div class="content-button">
            <button class="btn btn-action" [mat-dialog-close]="true" mat-button id="boton-credito-balloon{{templateSuffix !== '' ? '-b' : ''}}">
                {{ "CREDIT.typeDialog.ballon.button" | translate }}
            </button>
        </div>
    </div>
</section>
  
